import script from "./VPagination.vue?vue&type=script&lang=ts&setup=true"
export * from "./VPagination.vue?vue&type=script&lang=ts&setup=true"

import "./VPagination.vue?vue&type=style&index=0&id=64e1dfd3&lang=sass"

const __exports__ = script;

export default __exports__